'use client';

import { useState } from 'react';
import Link from 'next/link';


import Icon from '@/components/ui/AppIcon';
import PWAInstallPrompt from './PWAInstallPrompt';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Home', href: '/homepage' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Our Approach', href: '/our-approach' },
    { label: 'Case Studies', href: '/case-studies' },
    { label: 'Contact', href: '/contact' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-16 lg:h-20">
            <Link href="/homepage" className="flex items-center py-2">
              <span className="text-2xl sm:text-3xl font-bold text-institutional">
                Diaax
              </span>
            </Link>

            <nav className="hidden lg:flex items-center space-x-8">
              {navigationItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="text-sm font-medium text-text-secondary hover:text-institutional transition-fast relative group"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-institutional group-hover:w-full transition-all duration-300"></span>
                </Link>
              ))}
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <Link
                href="/contact"
                className="px-6 py-2.5 bg-institutional text-institutional-foreground font-semibold rounded-md hover:bg-institutional/90 transition-fast institutional-shadow"
              >
                Request Conversation
              </Link>
            </div>

            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 text-text-secondary hover:text-institutional transition-fast"
              aria-label="Toggle mobile menu"
            >
              <Icon name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-background border-t border-border animate-slide-in-down">
            <nav className="container mx-auto px-4 py-4 space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-4 py-3 text-sm font-medium text-text-secondary hover:text-institutional hover:bg-surface rounded-md transition-fast"
                >
                  {item.label}
                </Link>
              ))}
              <Link
                href="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-4 py-3 mt-4 bg-institutional text-institutional-foreground font-semibold text-center rounded-md hover:bg-institutional/90 transition-fast"
              >
                Request Conversation
              </Link>
            </nav>
          </div>
        )}
      </header>
      <PWAInstallPrompt />
    </>
  );
};

export default Header;